import { config as AppConfig } from "features/user/components/UserPanel/config";
import { EntityModelGrantAndFunctionDto } from "openapi";
import {
  NavButtonConfig,
  NavMenuConfig,
  NavSubMenuName,
} from "features/common/components/NavMenu/NavMenu.types";
import { toCamelCase } from "features/common/utils/textTransform";

export enum FunctionClassEnum {
  RECONCILIATION = "RECONCILIATION",
  STATISTICS = "STATISTICS",
  IMPORT = "IMPORT",
  EXPORT = "EXPORT",
}

function isValidFunctionClass(value: string): value is FunctionClassEnum {
  return Object.values(FunctionClassEnum).includes(value as any);
}

const createBtnConfigFromGrant = (
  userGrant: EntityModelGrantAndFunctionDto,
  appConfig: typeof AppConfig
): NavButtonConfig => {
  const { rootPages, modals, explorers } = appConfig;

  const buttonLabel = userGrant.function.description;

  const navButtonConfig: NavButtonConfig = {
    label: buttonLabel,
    openModal: false,
    openExplorer: false,
  };

  const computedModalName = `${buttonLabel} ${userGrant.function.codeFunction}`;
  if (modals.has(computedModalName)) {
    navButtonConfig.modalConfig = modals.get(computedModalName);
    navButtonConfig.openModal = true;
  } else if (rootPages.has(buttonLabel)) {
    navButtonConfig.route = rootPages.get(buttonLabel)?.route;
  } else if (explorers.includes(buttonLabel)) {
    navButtonConfig.openExplorer = true;
  }

  return navButtonConfig;
};

/**
 * Starting from the fetched user grants,  generate a config to renderer
 * all (or a subsets) of buttons in the config.
 */
export const createNavConfigFromGrants = (
  userGrants: EntityModelGrantAndFunctionDto[]
): NavMenuConfig =>
  userGrants.reduce((navMenuConfig, grantFunc) => {
    if (
      grantFunc.function.functionClass &&
      isValidFunctionClass(grantFunc.function.functionClass)
    ) {
      const navSubMenuName = toCamelCase(
        grantFunc.function.functionClass
      ) as NavSubMenuName;

      if (!navMenuConfig.hasOwnProperty(navSubMenuName)) {
        navMenuConfig[navSubMenuName] = [];
      }

      const buttonConfigInserted = navMenuConfig[navSubMenuName]!.find(
        (btn) => btn.label === grantFunc.function.description
      );

      if (!buttonConfigInserted && grantFunc.grant === "R") {
        const navButton = createBtnConfigFromGrant(grantFunc, AppConfig);
        navMenuConfig[navSubMenuName]?.push(navButton);
      }
    }

    return navMenuConfig;
  }, {} as NavMenuConfig);
